// Centralized API URL configuration
// Automatically detects the correct backend URL based on the environment

export const getApiUrl = () => {
    // 1. Environment variable explicitly set has the highest priority
    if (process.env.REACT_APP_API_URL) {
        return process.env.REACT_APP_API_URL;
    }

    const hostname = window.location.hostname;
    
    // 2. Production domain (Railway new architecture)
    if (hostname.includes('pollaremakia.com')) {
        return 'https://api.pollaremakia.com/api';
    }
    
    // 3. Localhost and default fallback
    return 'http://localhost:8001/api';
};

export const getBackendUrl = () => {
    const apiUrl = getApiUrl();
    if (apiUrl.endsWith('/api')) {
        return apiUrl.slice(0, -4);
    }
    return apiUrl;
};

export const API = getApiUrl();
export const BACKEND_URL = getBackendUrl();
